import React from "react";
import Svgs from "./assets/landing.svg";
import "./App.css";
import Landing2 from "./assets/Landing2";
import Quoation from './components/rect/Quotation.jsx'

import './css/utils.css'

const App = () => {
  const height = window.screen.height;
  return (
    <div className="main" style={{ width: "100%" , position: 'absolute'}}>
      <Landing2 />
      <Quoation />
    </div>
  );
};

export default App;
